import { Button } from "@/components/ui/button";
import { hostPayLabel, type HostPayment } from "@shared/hostPayment";

/**
 * "Pay the host directly" block: the host's note (plain text, newlines kept)
 * and a button to their payment link. Without a link the amount goes in its
 * own line. Same layout as the emails (`_shared/hostPayment.ts`).
 */
export function HostPaymentBlock({ payment, amountLabel }: { payment: HostPayment; amountLabel: string | null }) {
  return (
    <div className="space-y-2">
      {!payment.url && amountLabel && <p className="text-sm font-bold text-foreground">Amount: {amountLabel}</p>}
      {payment.note && (
        <p className="whitespace-pre-line break-words rounded-lg border p-3 text-sm text-foreground">{payment.note}</p>
      )}
      {payment.url && (
        <Button asChild className="w-full">
          <a href={payment.url} target="_blank" rel="noopener noreferrer">
            {hostPayLabel(amountLabel)}
          </a>
        </Button>
      )}
    </div>
  );
}
